import { useState, useEffect } from "react";
import { Row, Col, Button, message, Form, Divider, Typography } from "../ui/ot";
import { useParams } from "react-router-dom";
import PageDesign from "./views/page_design";
import { usePageManagement } from "./controller/page_management_controller";
import PageManagementForm from "./views/page_management_form";
import { useNavigate } from 'react-router-dom';

const PageSetting = ({ prefixTitle = "" }) => {
    const navigate = useNavigate()
    const { permissionName, page_id } = useParams();
    const [pageContainerData, setPageContainerData] = useState([]);
    const [colorPicker, setColorPicker] = useState();
    const [fontSizeSlider, setFontSizeSlider] = useState(5);
    const [form] = Form.useForm();
    const onSavePageData = (basicData) => {
        let pageDesignData = pageContainerData

        let permission_page_data = (basicData?.permission_page_data || []).map(
            (val) => {
                return {
                    permission_id:
                        val
                };
            }
        );
        let page_menu_data = (basicData?.page_menu_data || []).map((val) => {
            return { menu_id: val };
        });
        let property_json = JSON.stringify({
            backgroundImage: basicData?.property_json?.backgroundImage
        })
       
        basicData = {
            ...basicData,
            page_menu_data,
            permission_page_data,
            property_json
        }

        pageDesignData = (pageDesignData || []).map((pageDesign) => {
            return {
                ...pageDesign,
                permission_frontend_row_data: pageDesign?.page_frontend_row_data

            }
        })
        let values = {
            ...basicData,
            frontend_column_frontend_component_blog_type_data: pageDesignData
        }
        patchPageManagementData(values)
    }
    const onFormFinish = (values) => {
        if (values) {
            onSavePageData(values)
        }

    };

    const {
        PageManagementData,
        getPageManagementData,
        patchPageManagementData,
    } = usePageManagement({
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode === 'patch') {
                if (status === "success") {
                    if (axiosMode === "post") {
                        message.success("新增成功");
                    } else if (axiosMode === "patch") {
                        message.success("修改成功");
                    } else if (axiosMode === "delete") {
                        message.success("刪除成功");
                    }
                } else if (status === "error") {
                    if (axiosMode === "post") {
                        message.error("新增失敗");
                    } else if (axiosMode === "patch") {
                        message.error("修改失敗");
                    } else if (axiosMode === "delete") {
                        message.error("刪除失敗");
                    }
                }
                getPageManagementData({
                    page_id
                })
            }
        },
        onBefore: ({ axiosMode, status }) => { },
    });

    useEffect(() => { }, [pageContainerData]);

    useEffect(() => {
        setPageContainerData((prev) => {
            // console(findRowData('delete', prev, rowIndex))
            return prev.map((map_item) => ({
                ...map_item,
                page_frontend_row_data: map_item?.page_frontend_row_data?.map(
                    (columnData, columnIndex) => {
                        return {
                            ...columnData,
                            frontend_row_frontend_column_data:
                                columnData?.frontend_row_frontend_column_data?.map(
                                    (componentData, componentIndex) => {
                                        return {
                                            ...componentData,
                                            frontend_column_frontend_component_blog_type_data:
                                                componentData.frontend_column_frontend_component_blog_type_data?.map(
                                                    (
                                                        blogTypeData,
                                                        componentIndex
                                                    ) => {
                                                        return {
                                                            ...blogTypeData,
                                                            frontend_column_frontend_component_blog_type_blog_data:
                                                                blogTypeData?.frontend_column_frontend_component_blog_type_blog_data?.map(
                                                                    (
                                                                        blogTypeBlogData,
                                                                        componentIndex
                                                                    ) => {
                                                                        return {
                                                                            ...blogTypeBlogData,
                                                                            property_json:
                                                                            {
                                                                                ...blogTypeData.property_json,
                                                                                fontSizeScale:
                                                                                    (
                                                                                        0.5 +
                                                                                        0.1 *
                                                                                        fontSizeSlider
                                                                                    ).toFixed(
                                                                                        1
                                                                                    ),
                                                                                color: colorPicker,
                                                                            },
                                                                        };
                                                                    }
                                                                ),
                                                        };
                                                    }
                                                ),
                                        };
                                    }
                                ),
                        };
                    }
                ),
            }));
        });
    }, [fontSizeSlider, colorPicker]);


    useEffect(() => {
        if (page_id) {
            getPageManagementData({
                page_id: page_id,
            });
        }
        document.title = `${prefixTitle} | 頁面編排`

    }, [page_id]);

    useEffect(() => {
        let firstData = (PageManagementData || []).find((ele) => true);
        if (firstData) {
            let page_menu_data = (firstData?.page_menu_data || []).map(
                (value) => {
                    return value?.menu_id
                }
            );
            let permission_page_data = (
                firstData?.permission_page_data || []
            ).map((value) => {
                return value?.permission_id
            });
            // 頁面基本資料設定 初始化
            form.setFieldsValue({
                page_id: firstData?.page_id,
                name_language_data: firstData?.name_language_data,
                page_menu_data: page_menu_data,
                permission_page_data: permission_page_data,
            });
            setPageContainerData(() => {
                return firstData?.frontend_component_blog_type_data || [];
            });
        }
    }, [PageManagementData]);
    return (
        <Row gutter={[8, 8]}>
            <Col lg={24} md={24} sm={24} xs={24}>
                <Typography.Title
                    level={3}
                >
                    頁面基本資料設定
                </Typography.Title>
                <Row
                    gutter={[8, 8]}
                    style={{ justifyContent: "end" }}
                >
                    <Col>
                        <Button
                            onClick={() => {
                                navigate(`/officialweb/admin/pageSetting`)
                            }}
                            htmlType="button" size="large">
                            取消
                        </Button>
                    </Col>

                    <Col>
                        <Button
                            onClick={() => {
                                form.submit() //觸發基本資料form送出
                            }}
                            type="primary" size="large">
                            儲存
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            onClick={() => {
                                window.open('/officialweb/frontend/previewPage?' + (new URLSearchParams({ page_id: page_id }).toString()))
                            }}
                            type="primary" size="large">
                            預覽
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <PageManagementForm
                            propsForm={form}
                            onFormFinish={onFormFinish}
                        ></PageManagementForm>
                    </Col>
                </Row>
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
                <Divider />
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
                <Typography.Title
                    level={3}
                >
                    頁面編排設計
                </Typography.Title>

                <PageDesign
                    frontend_component_blog_type_data={
                        pageContainerData
                    }
                    setPageContainerData={setPageContainerData}
                />
            </Col>
        </Row>
    );
};
export default PageSetting;